// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import VueMoment from 'vue-moment';
import Vue2Filters from 'vue2-filters';
import moment from 'moment'
Vue.prototype.moment = moment
import App from './App';
import router from './router';
/* import 'buefy/dist/buefy.css' */
Vue.config.productionTip = false;
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)
// if you don't want install the component globally
Vue.use(VueYouTubeEmbed, { global: false })
// if you want to install the component globally with a different name
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" })

const EventBus = new Vue();
Vue.prototype.$bus = EventBus;
Vue.use(Buefy, {
  defaultIconPack: 'fas'
});
Vue.use(VueMoment);
Vue.use(Vue2Filters);



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

export default EventBus;



// WEBPACK FOOTER //
// ./src/main.js